const WAVE = '/images/elite/trust-markers/cards-wave.svg'

/** Figma card frame 280×168 — PNGs exported at 3×. */
const CARD = { width: 280, height: 168 } as const

const TRUST_CARDS = [
  '/images/elite/trust-markers/trust-card-investors.png',
  '/images/elite/trust-markers/trust-card-ria.png',
  '/images/elite/trust-markers/trust-card-commissions.png',
  '/images/elite/trust-markers/trust-card-founder.png',
  '/images/elite/trust-markers/trust-card-experience.png',
  '/images/elite/trust-markers/trust-card-vcs.png',
  '/images/elite/trust-markers/trust-card-award.png',
  '/images/elite/trust-markers/trust-card-leadership.png'
] as const

export default function CardsTrustMarker() {
  return (
    // z-0 contains the horizontal-scroll compositor layer so it cannot paint over fixed CTAs
    <div className='relative z-0 -mx-5'>
      <div className='relative w-full overflow-hidden rounded-xl bg-white'>
        <img
          alt=''
          src={WAVE}
          className='pointer-events-none absolute left-[-40%] top-[-20%] z-0 h-[140%] w-[160%] max-w-none rotate-[27deg] object-contain opacity-80'
        />
        <div className='relative flex flex-col gap-5 pt-8'>
          <p className='px-5 text-base font-medium leading-[1.4] text-[#3D3D3D]'>
            Building <span className='text-[#995501]'>India's most trusted <br /> advisory platform</span>
          </p>
          <div className='flex snap-x snap-mandatory gap-3 overflow-x-auto overflow-y-hidden px-5 pb-6 no-scrollbar [scroll-padding-inline:20px]'>
            {TRUST_CARDS.map((src) => (
              <div
                key={src}
                className='shrink-0 snap-start overflow-hidden rounded-xl'
                style={{ width: CARD.width, height: CARD.height }}
              >
                <img
                  alt=''
                  src={src}
                  className='h-full w-full object-cover object-center'
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
